import { useState } from 'react';
import { toast } from 'react-toastify';
import { Btn } from '../../components/ui';
import { adminAPI } from '../../api';

const today = () => new Date().toISOString().slice(0, 10);
const yearAgo = () => {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 1);
  return d.toISOString().slice(0, 10);
};

export default function ExportsTab() {
  const [from, setFrom] = useState(yearAgo());
  const [to, setTo]     = useState(today());
  const [consentedOnly, setConsentedOnly] = useState(false);
  const [busy, setBusy] = useState('');

  const download = async (kind) => {
    setBusy(kind);
    try {
      const params = { from, to };
      if (kind === 'research' && consentedOnly) params.consented_only = 'true';

      const res = await adminAPI.download(adminAPI.exportUrl(kind, params));

      // Hand the blob to the browser as a file.
      const url = URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = `elo-${kind}-${from}-to-${to}.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
      toast.success('Export downloaded.');
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.status === 403
        ? 'You do not have permission for that export.'
        : 'Could not build that export.');
    } finally { setBusy(''); }
  };

  return (
    <>
      <div className="adm-toolbar">
        <div style={{ flex: 1 }}>
          <div className="sheet-lbl" style={{ marginTop: 0 }}>From</div>
          <input className="fi" type="date" value={from} onChange={e => setFrom(e.target.value)} />
        </div>
        <div style={{ flex: 1 }}>
          <div className="sheet-lbl" style={{ marginTop: 0 }}>To</div>
          <input className="fi" type="date" value={to} onChange={e => setTo(e.target.value)} />
        </div>
      </div>

      <div className="adm-card">
        <div className="adm-card-title">Growth data</div>
        <div className="adm-export-note">
          One row per evidence note, naming the school, teacher and observer. For
          the people accountable for those schools. Scoped to what you can see in
          the app.
        </div>
        <Btn variant="dark" onClick={() => download('growth')} loading={busy === 'growth'}>
          Download growth CSV
        </Btn>
      </div>

      <div className="adm-card">
        <div className="adm-card-title">Research data</div>
        <div className="adm-export-note">
          Anonymised. Schools and teachers appear as research ids, and{' '}
          <strong>student names are never included</strong> — the observer told the
          teacher those stay between them. Includes the bucket decision capture,
          where the overrides are.
        </div>

        <label className="adm-perm" style={{ marginBottom: 10 }}>
          <input type="checkbox" checked={consentedOnly}
                 onChange={e => setConsentedOnly(e.target.checked)} />
          <span>
            <span className="adm-perm-name">Consenting teachers only</span>
            <span className="adm-perm-code">
              limits the file to accounts with research consent recorded
            </span>
          </span>
        </label>

        <Btn variant="dark" onClick={() => download('research')} loading={busy === 'research'}>
          Download research CSV
        </Btn>
      </div>
    </>
  );
}
